// extracted by mini-css-extract-plugin
export var Section = "Presentations-module--Section--a8R7O";
export var SectionTitle = "Presentations-module--SectionTitle--UVZlV";
export var arrowLeft = "Presentations-module--arrowLeft--ocMnd";
export var arrowRight = "Presentations-module--arrowRight--EU-sZ";